import React from "react"
import { Grid, Typography, Paper } from "@mui/material"

import Main from "./components/Main"

const posts = [
  <Paper
    elevation={0}
    sx={{
      my: 2,
      p: 2,
      bgcolor: "grey.200",
    }}>
    <Typography>
      <h2>Hinweis für minderjährige Nutzer</h2>
      <h3>Für minderjährige Nutzer (unter 18 Jahren)</h3>
      Ich bestätige, dass meine Eltern bzw. Erziehungsberechtigten mit meiner Registrierung auf der Plattform, der Speicherung und Verarbeitung meiner
      personenbezogenen Daten sowie der Nutzung der Plattform zum Kauf und Verkauf von Büchern einverstanden sind.
      <h3>Für volljährige Nutzer (ab 18 Jahren)</h3>
      Ich stimme der Speicherung und Verarbeitung meiner personenbezogenen Daten im Rahmen der Registrierung und Nutzung der Plattform zu.
    </Typography>
  </Paper>,
]

const MinorInfo = () => {
  return (
    <>
      <Grid container spacing={5} sx={{ mt: 1 }}>
        <Main title="Hinweis für minderjährige Nutzer" posts={posts} fullSize />
      </Grid>
    </>
  )
}

export default MinorInfo
